// SocketComponent.js
import { socketUrl } from "config/defaultUrl";
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import io from "socket.io-client";
import { successKYPResult } from "store/slice/kyp.slice";
import { getPolicyDetailThunk } from "store/thunk/kyp.thunk";
import { useAppDispatch } from "utils/hooks";

const SocketComponent = () => {
  const dispatch = useAppDispatch();
  const params: any = useParams();

  const fetchPolicyDetails = async () => {
    await dispatch(getPolicyDetailThunk(params?.policyId))
      .unwrap()
      .then((data) => {
        if (data?.success) {
          dispatch(successKYPResult(data?.data));
        }
      });
  };

  useEffect(() => {
    if (socketUrl) {
      const socket = io(socketUrl || "");
      socket.on("connect", () => {
        socket.on("KYP_RESULT_READY", async (data: any) => {
          try {
            if (data.policyId === params?.policyId) {
              fetchPolicyDetails();
            }
          } catch (error) {
            // console.log(error, "-------from socket");
          }
        });
      });

      return () => {
        socket.disconnect();
      };
    }
  }, []);

  return <></>;
};

export default SocketComponent;
